import { cn } from '@/lib/utils'
import { resolvePlayerAssetUrl } from '@/lib/player-api'

const AVATAR_COLORS = [
	'hsl(var(--info))',
	'hsl(var(--accent-blue))',
	'hsl(var(--primary-highlight))',
	'hsl(var(--warning))',
	'hsl(var(--accent-purple))',
	'hsl(var(--accent-pink))',
]

function getAvatarColor(seed: string): string {
	let hash = 0

	for (let index = 0; index < seed.length; index += 1) {
		hash = seed.charCodeAt(index) + ((hash << 5) - hash)
	}

	return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

interface P2pUserAvatarProps {
	username?: string | null
	avatarUrl?: string | null
	className?: string
}

export function P2pUserAvatar({ username, avatarUrl, className }: P2pUserAvatarProps) {
	const displayName = username?.trim() || 'Anonymous'
	const resolvedAvatarUrl = avatarUrl ? resolvePlayerAssetUrl(avatarUrl) : ''
	const color = getAvatarColor(displayName)

	if (resolvedAvatarUrl) {
		return <img src={resolvedAvatarUrl} alt='' aria-hidden className={cn('h-7 w-7 shrink-0 rounded-full object-cover', className)} />
	}

	return (
		<div
			className={cn('flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded-full text-xs font-semibold text-white', className)}
			style={{ backgroundColor: color }}
			aria-hidden
		>
			{displayName.charAt(0).toUpperCase()}
		</div>
	)
}
